/**
 * The seeker-chosen "what brings you here" category. This is booking-flow
 * metadata that rides along in the `concern` payload — it does not come
 * from the backend and has no dedicated API surface of its own.
 */
export type SessionTypeCategory =
  | "INDIVIDUAL_RELATIONSHIP_SUPPORT"
  | "COUPLE_COUNSELLING"
  | "BREAKUP_HEALING"
  | "MARRIAGE_SUPPORT"
  | "EMOTIONAL_SUPPORT"
  | "COMMUNICATION_ISSUES"
  | "FAMILY_PARTNER_CONFLICT"
  | "OTHER";

export const SESSION_TYPE_OPTIONS: {
  value: SessionTypeCategory;
  en: string;
  hi: string;
}[] = [
  {
    value: "INDIVIDUAL_RELATIONSHIP_SUPPORT",
    en: "Individual Relationship Support",
    hi: "व्यक्तिगत संबंध सहायता",
  },
  {
    value: "COUPLE_COUNSELLING",
    en: "Couple Counselling",
    hi: "युगल परामर्श",
  },
  {
    value: "BREAKUP_HEALING",
    en: "Breakup Healing",
    hi: "ब्रेकअप हीलिंग",
  },
  {
    value: "MARRIAGE_SUPPORT",
    en: "Marriage Support",
    hi: "विवाह सहायता",
  },
  {
    value: "EMOTIONAL_SUPPORT",
    en: "Emotional Support",
    hi: "भावनात्मक सहायता",
  },
  {
    value: "COMMUNICATION_ISSUES",
    en: "Communication Issues",
    hi: "संचार संबंधी समस्याएं",
  },
  {
    value: "FAMILY_PARTNER_CONFLICT",
    en: "Family / Partner Conflict",
    hi: "पारिवारिक/साथी संघर्ष",
  },
  {
    value: "OTHER",
    en: "Other",
    hi: "अन्य",
  },
];
